import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { PATHOLOGY_SPECIALTY_SLUG } from '@hms/shared';
import { doctorsApi } from '@/services/api/doctorsApi';

/** The signed-in doctor's own profile, read once: the review queue is for pathologists only (B45). */
export const useDoctorProfileStore = defineStore('doctorProfile', () => {
  const specialty = ref<string | null>(null);
  const loaded = ref(false);

  const isPathologist = computed(() => specialty.value === PATHOLOGY_SPECIALTY_SLUG);

  async function load(): Promise<void> {
    if (loaded.value) return;
    try {
      specialty.value = (await doctorsApi.getMyProfile()).specialty ?? null;
    } catch {
      // Without the profile the doctor is treated as not a pathologist; the API refuses a release anyway.
      specialty.value = null;
    } finally {
      loaded.value = true;
    }
  }

  function reset(): void {
    specialty.value = null;
    loaded.value = false;
  }

  return { specialty, isPathologist, load, reset };
});
